import { styled } from '@styles';

export const Wrapper = styled.div``;

export const Content = styled.div`
  .slice-item {
    margin: 2em auto;
  }
`;
